import { prepareMutiLineText } from "@shared/utils";
import { FileModel } from "@aecom/core";
import { DefaultSelection36RfiRejectDetailPayload } from "../api-generated";
import LocalContractUserService from "@services/local-contractUser.service";
export default class RejectHistoryTableItem
{
  public Sequence: number;
  public CoverSheet: FileModel[];
  public RejectedBy: string;
  public RejectedDate: string;
  public Note: string;
  public Collapse: boolean;
  
  constructor(item: DefaultSelection36RfiRejectDetailPayload, localContractUserService: LocalContractUserService, index: number) {
    this.Sequence = index + 1;

    const rejectedBy = localContractUserService.getUserInfo(item.UpdatedBy);
    if(rejectedBy)
    {
      const role = localContractUserService.getUserRole(item.UpdatedBy);
      this.RejectedBy = `${rejectedBy.displayName ?? ""} (${role ?? ""})`;
    }
    else {
      this.RejectedBy = "N/A";
    }
    this.RejectedDate = item.DateUpdated ? this.getFormatedDateAndTime(item.DateUpdated) : "N/A";
    this.Note = item.Note ? prepareMutiLineText(item.Note) : "N/A";
    this.Collapse = true;
  }

  private getFormatedDateAndTime(date: string): string {
    return `${new Date(date)
      .toLocaleDateString("en-US", {
        year: "numeric",
        month: "numeric",
        day: "numeric"
      })
      .replace(", ", "/")
      .replace(" ", "/")} ${new Date(date).toLocaleTimeString([], {
      hour: "numeric",
      minute: "2-digit"
    })}`;
  }
}
